import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'error-card',
  standalone: false,
  templateUrl: './error-card.component.html',
  styleUrl: './error-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorCardComponent {}
